import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { Formik, Field } from 'formik';
import {
    Button,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from "reactstrap";
import styled from 'styled-components';
import FileBase64 from 'react-file-base64';

import ActionIcon from '../../../custom/ActionIcon';
import dataSchema from './dataSchema';
import BackButton from '../../../custom/BackButton';
import { formatPhoneNumber, isValidPhoneNumber, notify, safeGet } from '../../../../utils';
import { ButtonGroup } from 'reactstrap';
import _ from 'lodash';
import moment from 'moment';
import WorkHours from './WorkHours';
import apiClient from '../../../../apiClient';
import useAppData from '../../../../customHooks/useAppData';
import useUser from '../../../../customHooks/useUser';
import Select from '../../../Select';

const STATUS = ['ACTIVE', 'INACTIVE'];
const STATUS_OPTIONS = STATUS.map((item) => ({
    label: item,
    value: item
}));

const ModalEditStations = ({
    open,
    handleModal,
    item,
    setCorpStationsData,
    updateStationsInfo,
    createCorpStation,
    modalTypeNew,
    deleteCorpStation,
    doors,
    s_dock_door,
    set_s_dock_door,
    addCorpDockDoor,
    removeCorpDockDoor,
    calloutNotificationNumbers,
    addCalloutNotificationNumber,
    deleteCalloutNotificationNumber,
    forklifts,
    addForklift,
    deleteForklift,
    stationHoursMap,
    launchUpdateWorkHours
}) => {

    const forkliftTypes = ['GAS', 'ELECTRIC'];

    const [phoneNumber, setPhoneNumber] = useState('');
    const [forklift, setForklift] = useState('');
    const [forkliftType, setForkliftType] = useState('');
    const [initialValues, setInitialValues] = useState({});
    const [imgKey, setImgKey] = useState(0);
    const toggle = () => handleModal(false);

    useEffect(() => {
        const values = {};
        for (let key in dataSchema.fields) {
            values[key] = modalTypeNew ? '' : (item && item[key]);
        }
        setInitialValues(values);
    }, [open, item, modalTypeNew]);

    const handleSubmit = (values) => {
        if (modalTypeNew) {
            createCorpStation(values);
        } else {
            updateStationsInfo(values);
        }
    }

    const handleAddCalloutNotificationNumber = async () => {
        await addCalloutNotificationNumber(phoneNumber, item.s_unit);
        setPhoneNumber('');
        notify('Added');
    }

    const handleAddForklift = async () => {
        await addForklift(forklift, forkliftType, item.s_unit);
        setForklift('');
        setForkliftType('');
        notify('Added');
    }

    const handleUploadLobbyImage = async (file) => {
        if (!item || !item.s_unit) {
            return;
        }
        const res = await apiClient.post('/updateStationLobbyImage', {
            s_unit: item.s_unit,
            existingUrl: item.s_lobby_image,
            file
        })
        setCorpStationsData(res.data);
        setImgKey(prev => prev + 1);
    }

    return (
        <CustomModal
            isOpen={open}
            toggle={toggle}
        >
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={dataSchema}
                validateOnMount={true}
            >
                {({ values, isValid, errors, setFieldValue }) => (
                    <>
                        <ModalHeader className={'d-flex'}>
                            <BackButton
                                classNames='pr-2'
                                onClick={toggle}
                            />
                            <h1>{modalTypeNew ? 'Create New Station' : 'Update Station Info.'}</h1>
                        </ModalHeader>
                        <ModalBody>
                            <FormContainer>
                                <CustomFormGroup>
                                    <Label className='mr-2'>Unit</Label>
                                    <CustomField type="text" name="s_unit" className="form-control" errors={errors} />
                                </CustomFormGroup>
                                <CustomFormGroup>
                                    <Label className='mr-2'>Phone</Label>
                                    <CustomField type="text" name="s_phone" className="form-control" errors={errors} />
                                </CustomFormGroup>
                                <CustomFormGroup>
                                    <Label className='mr-2'>Firms Code</Label>
                                    <CustomField type="text" name="s_firms_code" className="form-control" errors={errors} />
                                </CustomFormGroup>
                                <CustomFormGroup>
                                    <Label className='mr-2'>Airport</Label>
                                    <CustomField type="text" name="s_airport" className="form-control" errors={errors} />
                                </CustomFormGroup>
                                <CustomFormGroup>
                                    <Label className='mr-2'>Airport Code</Label>
                                    <CustomField type="text" name="s_airport_code" className="form-control" errors={errors} />
                                </CustomFormGroup>
                                <CustomFormGroup>
                                    <Label className='mr-2'>Import ISC</Label>
                                    <CustomField type="number" name="f_import_isc_cost" className="form-control" errors={errors} />
                                </CustomFormGroup>
                                <CustomFormGroup>
                                    <Label className='mr-2'>Import per KG</Label>
                                    <CustomField type="number" name="f_import_per_kg" className="form-control" errors={errors} />
                                </CustomFormGroup>
                                <CustomFormGroup>
                                    <Label className='mr-2'>Import min Charge</Label>
                                    <CustomField type="number" name="f_import_min_charge" className="form-control" errors={errors} />
                                </CustomFormGroup>
                                <CustomFormGroup>
                                    <Label className='mr-2'>Add Storage First Free Day</Label>
                                    <CustomField type="number" name="i_add_first_free_day" className="form-control" errors={errors} />
                                </CustomFormGroup>
                                <CustomFormGroup>
                                    <Label className='mr-2'>Add Storage Second Free Day</Label>
                                    <CustomField type="number" name="i_add_second_free_day" className="form-control" errors={errors} />
                                </CustomFormGroup>
                                <CustomFormGroup>
                                    <Label className='mr-2'>Add Storage First Free Day <span className={'bg-warning'}>PERISHABLE</span></Label>
                                    <CustomField type="number" name="i_add_first_free_day_perishable" className="form-control" errors={errors} />
                                </CustomFormGroup>
                                <CustomFormGroup>
                                    <Label className='mr-2'>Add Storage Second Free Day <span className={'bg-warning'}>PERISHABLE</span></Label>
                                    <CustomField type="number" name="i_add_second_free_day_perishable" className="form-control" errors={errors} />
                                </CustomFormGroup>
                                <CustomFormGroup>
                                    <Label className='mr-2'>Address</Label>
                                    <CustomField component="textarea" name="s_address" className="form-control" errors={errors} />
                                </CustomFormGroup>
                                <CustomFormGroup>
                                    <Label className='mr-2'>Map Link</Label>
                                    <CustomField component="textarea" name="s_map_link" className="form-control" errors={errors} />
                                </CustomFormGroup>
                                <CustomFormGroup>
                                    <Label className='mr-2'>Manager Email Address / Distribution List</Label>
                                    <CustomField type="email" name="s_manager_email" className="form-control" errors={errors} />
                                </CustomFormGroup>
                                <CustomFormGroup>
                                    <Label className='mr-2'>Status</Label>
                                    <Select 
                                        options={STATUS_OPTIONS}
                                        onChange={item => setFieldValue('s_status', item.value)}
                                        value={values['s_status']}
                                        width={300}
                                    />
                                </CustomFormGroup>
                            </FormContainer>
                            {
                                !modalTypeNew &&
                                <Fragment>
                                    <Section>
                                        <Label className='mr-2'>Work Hours</Label>
                                        <FlexContainer>
                                            {
                                                new Array(7).fill(0).map((item, i) => (
                                                    <WorkHours
                                                        dayNumber={i}
                                                        stationHoursMap={stationHoursMap}
                                                        launchUpdateWorkHours={launchUpdateWorkHours}
                                                    />
                                                ))
                                            }
                                        </FlexContainer>
                                    </Section>
                                    <Section>
                                        <AddDoorContainer>
                                            <Label className='mr-2' style={{ display: 'inline' }}>Dock Doors:</Label>
                                            <Input value={s_dock_door} onChange={(e) => set_s_dock_door(e.target.value)} type='text' style={{ display: 'inline', width: '200px' }} />
                                            <Button color='info' style={{ display: 'inline' }} className='ml-2' onClick={() => addCorpDockDoor()} disabled={s_dock_door.length < 1}>Add Door</Button>
                                        </AddDoorContainer>
                                        <DoorsContainer>
                                            {
                                                doors.map((d, i) => d.s_unit === item.s_unit &&
                                                    <Button className='my-2 mx-2' key={i}>
                                                        {d.s_dock_door}
                                                        <i onClick={(e) => removeCorpDockDoor(e, d.id)} style={{ fontSize: '20px' }} className='pl-2 far fa-times-circle' />
                                                    </Button>
                                                )
                                            }
                                        </DoorsContainer>
                                    </Section>
                                    <Section>
                                        <AddDoorContainer>
                                            <Label className='mr-2' style={{ display: 'inline' }}>Forklifts:</Label>
                                            <Input value={forklift} onChange={(e) => setForklift(e.target.value)} type='text' style={{ display: 'inline', width: '200px' }} />
                                            <ButtonGroup className='ml-2'>
                                                {
                                                    forkliftTypes.map((item, i) => (
                                                        <Button
                                                            onClick={() => setForkliftType(item)}
                                                            active={item === forkliftType}
                                                            key={i}
                                                        >
                                                            {item}
                                                        </Button>
                                                    ))
                                                }
                                            </ButtonGroup>
                                            <Button color='info' style={{ display: 'inline' }} className='ml-2' onClick={() => handleAddForklift()} disabled={forklift.length < 1 || !forkliftType}>Add Forklift</Button>
                                        </AddDoorContainer>
                                        <DoorsContainer>
                                            {
                                                forklifts.map((f, i) => f.unit === item.s_unit &&
                                                    <Button className='my-2 mx-2' key={i}>
                                                        {f.name} ({safeGet(f, 'type', '').substring(0, 1)})
                                                        <i onClick={() => deleteForklift(f.id)} style={{ fontSize: '20px' }} className='pl-2 far fa-times-circle' />
                                                    </Button>
                                                )
                                            }
                                        </DoorsContainer>
                                    </Section>
                                    <Section>
                                        <AddDoorContainer>
                                            <Label className='mr-2' style={{ display: 'inline' }}>Callout Notification Numbers:</Label>
                                            <Input
                                                value={phoneNumber ? formatPhoneNumber(phoneNumber) : ''}
                                                onChange={(e) => setPhoneNumber(e.target.value)}
                                                type='text'
                                                style={{ display: 'inline', width: '200px' }}
                                            />
                                            <Button color='info' style={{ display: 'inline' }} className='ml-2'
                                                onClick={() => handleAddCalloutNotificationNumber()}
                                                disabled={!isValidPhoneNumber(phoneNumber)}
                                            >
                                                Add
                                            </Button>
                                        </AddDoorContainer>
                                        <DoorsContainer>
                                            {
                                                calloutNotificationNumbers.map((n, i) => n.unit === item.s_unit &&
                                                    <Button className='my-2 mx-2' key={i}>
                                                        {formatPhoneNumber(n.phoneNumber)}
                                                        <i onClick={(e) => deleteCalloutNotificationNumber(n.id)} style={{ fontSize: '20px' }} className='pl-2 far fa-times-circle' />
                                                    </Button>
                                                )
                                            }
                                        </DoorsContainer>
                                    </Section>
                                    <Section>
                                        <Label>Lobby Image</Label>
                                        {
                                            item?.s_lobby_image ? (
                                                <LobbyImage
                                                    src={item.s_lobby_image}
                                                />
                                            ) : <h6>Not uploaded</h6>

                                        }
                                        <FileBase64
                                            onDone={handleUploadLobbyImage}
                                            key={imgKey}
                                        />
                                    </Section>
                                </Fragment>
                            }
                        </ModalBody>
                        <ModalFooter className={'w-100'}>
                            <div className={'w-100 d-flex justify-content-between'}>
                                <ActionIcon
                                    type={'delete'}
                                    onClick={() => deleteCorpStation(item.s_unit)}
                                />
                                <ActionIcon
                                    type={'save'}
                                    onClick={() => handleSubmit(values)}
                                    disabled={!isValid}
                                />
                            </div>
                        </ModalFooter>
                    </>
                )}
            </Formik>
        </CustomModal>
    );
}

const CustomModal = styled(Modal)`
    max-width: 1000px !important;
`;

const AddDoorContainer = styled.div`
    display: flex;
    align-items: center;
`;

const DoorsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    max-height: 172px;
    overflow-y: scroll;
`;

const FormContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
`;

const CustomFormGroup = styled(FormGroup)`
    flex: 1 1 300px;
`;

const CustomField = styled(Field)`
    border: ${p => (p.errors && p.errors[p.name]) && '1px solid red'};
`;

const Section = styled.div`
    border: 2px solid grey;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 10px;
    width: 100%;
`;

const FlexContainer = styled.div`
    display: flex;
    gap: 10px;
`;

const LobbyImage = styled.img`
    height: 100px;
    width: auto;
    display: block;
    margin-bottom: 10px;
`;

export default ModalEditStations;